<template>
    <section id="request-info">
        <div class="form">
            <div class="gsection-title">
                <h2 class="gtitle">Make JORNAY PM your methylphenidate of choice for school-aged (6 years and older) and
                    adult patients
                    with
                    ADHD
                </h2>
            </div>
            <div class="container content">
                <span class="large-text" style="margin-bottom:20px; font-size: 24px;">
                    Select all that apply:
                </span>

                <validation-observer v-slot="{ validate }" ref="observer">
                    <form ref="form" @submit.prevent="validate().then(afterValidation)"
                        :action="ironshoreContactMethod === 'Copay Cards' ? pardotCoPayFormHandlerUrl : pardotFormHandlerUrl"
                        method="post">
                        <div class="d-flex flex-column">
                            <validation-provider name="Contact method" rules="contactMethodsSelected:receiveUpdates"
                                v-slot="{ errors, invalid }">
                                <!--<irsh-checkboxes v-model="ironshoreContactMethod" id="c" data-category="Request Information"
                                    data-label="I’d like materials to help educate my patients about JORNAY PM"
                                    label="I’d like materials to help educate my patients about <span class='nowrap'>JORNAY PM</span>"
                                    name="contactMethod" native-value="Copay Cards">
                                </irsh-checkboxes>
                                <irsh-checkboxes v-model="ironshoreContactMethod" id="a" data-category="Request Information"
                                    data-label="Learn more about JORNAY PM. Connect with an Ironshore sales representative"
                                    label="Learn more about JORNAY PM. Connect with an Ironshore sales representative"
                                    name="contactMethod" native-value="Ironshore Representative">
                                    <p class="note mb-0">
                                        By making this selection, you are giving Ironshore Pharmaceuticals,
                                        Inc. permission to contact you with the information you have requested.
                                        Ironshore Pharmaceuticals will not sell or lease any of your information to
                                        third parties.
                                        <a href="https://www.ironshorepharma.com/privacy.html" target="_blank"
                                            data-category="Request Information" data-label="View our privacy policy - Top">
                                            View our privacy policy.
                                        </a>
                                    </p>
                                </irsh-checkboxes>
                                <irsh-checkboxes v-model="ironshoreContactMethod" rules="required"
                                    label="Have a question about the clinical characteristics or trial data for JORNAY PM? Connect with a Medical Science Liaison"
                                    id="B" data-category="Request Information"
                                    data-label="CHave a question about the clinical characteristics or trial data for JORNAY PM? Connect with a Medical Science Liaison"
                                    name="contactMethod" native-value="Medical Liason">
                                    <p class="note mb-0">
                                        By making this selection, you are giving Ironshore Pharmaceuticals,
                                        Inc. permission to contact you with the information you have requested.
                                        Ironshore Pharmaceuticals will not sell or lease any of your information to
                                        third
                                        parties.
                                        <a href="https://www.ironshorepharma.com/privacy.html" target="_blank"
                                            data-category="Request Information" data-label="View our privacy policy - Top">
                                            View our privacy policy.
                                        </a>
                                    </p>
                                </irsh-checkboxes>-->
                                <irsh-radio v-model="ironshoreContactMethod" id="c" data-category="Request Information"
                                    data-label="Receive materials to help educate your patients about JORNAY PM"
                                    label="Receive materials to help educate your patients about JORNAY PM"
                                    name="contactMethod" native-value="Copay Cards">
                                </irsh-radio>
                                <irsh-radio v-model="ironshoreContactMethod" id="a" data-category="Request Information"
                                    data-label="Learn more about JORNAY PM. Connect with a Collegium sales representative"
                                    label="Learn more about JORNAY PM. Connect with a Collegium sales representative"
                                    name="contactMethod" native-value="Ironshore Representative">
                                    <p class="note mb-0">
                                        By making this selection, you are giving Collegium Pharmaceutical, Inc.,
                                        Inc. permission to contact you with the information you have requested.
                                        Collegium Pharmaceutical, Inc. will not sell or lease any of your information to
                                        third parties.
                                        <a href="https://www.collegiumpharma.com/privacy-policy/" target="_blank"
                                            data-category="Request Information"
                                            data-label="View our privacy policy - Top">
                                            View our privacy policy.
                                        </a>
                                    </p>
                                </irsh-radio>
                                <irsh-radio v-model="ironshoreContactMethod" rules="required"
                                    label="Connect with a Medical Science Liaison for questions regarding clinical characteristics or trial data for <span class='nowrap'>JORNAY PM</span>"
                                    id="B" data-category="Request Information"
                                    data-label="Connect with a Medical Science Liaison for questions regarding clinical characteristics or trial data for JORNAY PM"
                                    name="contactMethod" native-value="Medical Liason">
                                    <p class="note mb-0">
                                        By making this selection, you are giving Collegium Pharmaceutical, Inc.,
                                        Inc. permission to contact you with the information you have requested.
                                        Collegium Pharmaceutical, Inc. will not sell or lease any of your information to
                                        third
                                        parties.
                                        <a href="https://www.collegiumpharma.com/privacy-policy/" target="_blank"
                                            data-category="Request Information"
                                            data-label="View our privacy policy - Top">
                                            View our privacy policy.
                                        </a>
                                    </p>
                                </irsh-radio>
                                <label v-if="invalid" class="error">{{ errors[0] }}</label>
                            </validation-provider>
                            <!-- <p class="mt-4 mb-3">
                                <i>All fields required unless otherwise indicated.</i>
                            </p> 
                            <div class="custom-drop" v-show="isCopayCardsMethodSelected">
                                <irsh-dropdown class="title_field mb-30-px" :values="quantities" v-model="selectedQuantity"
                                    title="Quantity" name="Number_of_Copay_Cards_Requested"
                                    id="Number_of_Copay_Cards_Requested" rules="copayCardsInfoRequired:contactMethod" />
                                <div class="offer d-flex mt-2 ml-3">
                                    <p class="dropdown__title">Saving Cards</p>
                                    <div class="icon">i</div>
                                    <div class="tip flex-column">
                                        <span class="text-nowrap">With these savings cards, patients pay $0 for the
                                            first fill, and as little<br></span>
                                        <span class="text-nowrap">as $30 for refills. Terms and conditions apply.
                                            Cards will be shipped<br></span>
                                        <span class="text-nowrap">to you directly or delivered by your sales
                                            representative.</span>
                                    </div>
                                </div>
                            </div>
                            -->
                            <irsh-dropdown class="title_field mb-30-px" :values="salutations"
                                v-model="selectedSalutation" title="Title<span class='optional'> (optional)</span>"
                                name="salutation" id="salutation" />
                            <irsh-textbox class="mb-30-px" title="First name" name="f_name" id="f_name"
                                v-model="firstName" rules='required' />
                            <irsh-textbox class="mb-30-px" title="Last name" name="l_name" id="l_name"
                                v-model="lastName" rules='required' />
                            <irsh-dropdown class="specialty mb-30-px" :values="specialties" v-model="selectedSpecialty"
                                title="Specialty" rules='required' name="Specialty" id="dropdown" />
                            <div v-show="isCopayCardsMethodSelected">
                                <p class="mb-3"><b>Shipping Address (We will not use this address in future):</b>
                                </p>
                                <p class="mb-3">
                                    <validation-provider name="addressLocation"
                                        rules="copayCardsInfoRequired:contactMethod" v-slot="{ errors, invalid }">
                                        <irsh-radio label="Home" id="addressLocationHome" v-model="addressLocation"
                                            data-category="Address Location" data-label="Home" native-value="Home"
                                            name="Address_Location">
                                            <p class="note mb-0">
                                                Your cards will be mailed to your home within five business days. We
                                                will not retain your home address in our records.
                                            </p>
                                        </irsh-radio>
                                        <irsh-radio label="Work" id="addressLocationWork" v-model="addressLocation"
                                            data-category="Address Location" data-label="Work" native-value="Work"
                                            name="Address_Location">
                                            <p class="note mb-0">
                                                Your cards will be shipped or delivered directly to your office by
                                                your sales representative.
                                            </p>
                                        </irsh-radio>
                                        <label v-if="invalid" class="error">{{ errors[0] }}</label>
                                    </validation-provider>
                                </p>
                                <irsh-textbox class="mb-30-px" title="Company" name="company" id="company"
                                    v-model="company" rules="copayCardsInfoCompanyRequired:addressLocation" />
                                <irsh-textbox class="mb-30-px" title="Address Line 1*" name="address1" id="address1"
                                    v-model="address1" rules="copayCardsInfoRequired:contactMethod" />
                                <irsh-textbox class="mb-30-px" title="Address Line 2" name="address2" id="address2"
                                    v-model="address2" />
                                <irsh-textbox class="mb-30-px" title="City*" name="city" id="city" v-model="city"
                                    rules="copayCardsInfoRequired:contactMethod" type="text" />
                                <irsh-dropdown class="title_field mb-30-px" :values="states" v-model="selectedState"
                                    title="State*" name="state" id="state"
                                    rules="copayCardsInfoRequired:contactMethod" />
                            </div>
                            <irsh-textbox class="mb-30-px zip_code" title="ZIP" name="zip" id="zip" v-model="zipCode"
                                rules="required|length:5" max-length="5" type="number" />
                            <irsh-textbox class="mb-30-px" title="Email address" name="email" id="email" v-model="email"
                                rules='required|email' />
                            <div v-show="ironshoreContactMethod != null">
                                <p class="mt-0 mb-3 preferredmethod__title">
                                    Preferred method of contact
                                </p>
                                <validation-provider name="preferredMethod" rules="required" v-slot="{ errors }"
                                    :disabled="ironshoreContactMethod == null">
                                    <irsh-radio v-model="preferredContactMethod" label="Email" id="emailCheck"
                                        name="preferredMethod" native-value="email">
                                    </irsh-radio>
                                    <irsh-radio v-model="preferredContactMethod" label="Phone" id="phoneCheck"
                                        name="preferredMethod" native-value="phone">
                                    </irsh-radio>
                                    <label class="error">{{ errors[0] }}</label>
                                </validation-provider>
                                <irsh-textbox :is-visible="isPhoneContactSelected" class="phone" type="number"
                                    title="Phone number" name="phone" id="phone" v-model="phoneNumber"
                                    rules="required|length:10" max-length="10" />
                            </div>

                            <validation-provider name="certifyUpdates">
                                <irsh-checkbox class="receive_emails mt-30-px" v-model="certifySelected"
                                    id="certifySelected" name="certifySelected" v-show="isCopayCardsMethodSelected"
                                    title="I certify that I am a U.S. health care professional. I understand that any
                                        services and information provided are not intended as an improper
                                        inducement but are intended to assist me in forming my own
                                        conclusions and making my own decisions.">
                                </irsh-checkbox>
                            </validation-provider>
                            <input type="hidden" name="profile_type"
                                :value="isCopayCardsMethodSelected && certifySelected ? 'Healthcare Professional' : null" />
                            <validation-provider name="Receive updates" rules="receiveUpdatesSelected:contactMethod"
                                v-slot="{ errors }">
                                <irsh-checkbox class="receive_emails mt-30-px" id="policy"
                                    title="I’d like to receive email updates about JORNAY PM and how it can provide my patients with all-day ADHD symptom control <span class='optional'>(optional)</span>"
                                    name="receiveUpdates" v-model="receiveEmailSelected">
                                    <p class="note mb-0" v-show="receiveEmailSelected">
                                        By checking this box, you are giving Collegium Pharmaceutical, Inc. permission to send or contact you with the information
                                        you have requested, as well as information and updates on JORNAY PM
                                        or other Collegium Pharmaceutical, Inc. products in the future.
                                        Collegium Pharmaceutical, Inc. will not sell or lease
                                        any of your information to third parties.
                                        <a href="https://www.collegiumpharma.com/privacy-policy/" target="_blank"
                                            data-category="Request Information"
                                            data-label="View our privacy policy - Bottom">
                                            View our privacy policy.
                                        </a>
                                    </p>
                                </irsh-checkbox>
                                <label class="error">{{ errors[0] }}</label>
                            </validation-provider>
                            <button type="submit" class="submit"><span>Send Request</span>
                            </button>
                        </div>
                    </form>
                </validation-observer>


                <div class="content_block"><b>Collegium Pharmaceutical, Inc.</b></div>
                <div class="content_block">100 Technology Center Dr #300</div>
                <div class="content_block">Stoughton, MA 02072</div>
                <div class="content_block fx-cntct">United States</div>
                <h2 class="title mb-0">
                    Contact Collegium Medical Information:
                </h2>
                <div class="contact_link">
                    Email:
                    <a class="link" href="mailto:MICC.Collegium@4cPharma.com"
                        data-category="Request Information" data-label="MICC.Collegium@4cPharma.com">
                        MICC.Collegium@4CPharma.com
                    </a>
                </div>
                <div class="contact_link">
                    Call:
                    <a class="link dark-blue" href="tel:18553315615" data-category="Request Information"
                        data-label="1-855-331-5615">
                        1-855-331-5615
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>


<script>

const url = "https://api.zippopotam.us/US/";
import axios from "axios";
import qs from "query-string";

import checkbox from "../../components/Checkbox";
import checkboxes from "../../components/Checkboxes";
import radio from "../../components/Radio";
import dropdown from "../../components/Dropdown";
import textbox from "../../components/Textbox";


import { extend, localize, setInteractionMode } from "vee-validate";
import { states } from "../../models/states";


setInteractionMode("eager");

extend("contactMethodsSelected", {
    validate: (value, { target }) => {
        return value != null || target === true;
    },
    params: [
        {
            name: "target",
            isTarget: true,
        },
    ],
    computesRequired: true,
});

extend("receiveUpdatesSelected", {
    validate: (value, { target }) => {
        return value === true || target != null;
    },
    params: [
        {
            name: "target",
            isTarget: true,
        },
    ],
    computesRequired: true,
});

extend("copayCardsInfoRequired", {
    validate: (value, { target }) => {
        return target !== "Copay Cards" || (value != null && value !== "");
    },
    params: [
        {
            name: "target",
            isTarget: true,
        },
    ],
    computesRequired: true,
});

extend("copayCardsInfoCompanyRequired", {
    validate: (value, { target }) => {
        return (
            target == null || target !== "Work" || (value != null && value !== "")
        );
    },
    params: [
        {
            name: "target",
            isTarget: true,
        },
    ],
    computesRequired: true,
});






export default {

    components: {
        "irsh-checkbox": checkbox,
        "irsh-checkboxes": checkboxes,
        "irsh-radio": radio,
        "irsh-dropdown": dropdown,
        "irsh-textbox": textbox,
    },
    data() {
        return {
            ironshoreContactMethod: null,
            pardotFormHandlerUrl: "https://www2.ironshorepharma.com/l/231552/2019-05-14/fl2m4", // prod
            pardotCoPayFormHandlerUrl:
                "https://go.pardot.com/l/231552/2020-05-27/tg2lg", //prod
            //pardotFormHandlerUrl : "https://go.pardot.com/l/231552/2020-05-11/t7vpj", // uat
            //pardotCoPayFormHandlerUrl : "https://go.pardot.com/l/231552/2020-05-19/tb2f6", // uat
            //pardotFormHandlerUrl : "https://go.pardot.com/l/231552/2020-05-11/t7r1s", // dev
            //pardotCoPayFormHandlerUrl : "https://go.pardot.com/l/231552/2020-05-19/tb1rj", // dev
            selectedQuantity: null,
            company: null,
            addressLocation: null,
            address2: null,
            address1: null,
            city: null,
            certifySelected: "",
            quantities: [5, 10, 15],
            salutations: ["Dr.", "Mr.", "Mrs.", "Ms."],
            specialties: [
                "Pediatrician",
                "Family Practice",
                "Internal Medicine",
                "General Psychiatrist",
                "Pediatric Psychiatrist",
                "NP/PA",
                "Other",
            ],
            states: states.map((s) => s.Code),
            selectedSalutation: null,
            selectedState: null,
            firstName: null,
            lastName: null,
            email: null,
            zipCode: null,
            preferredContactMethod: null,
            phoneNumber: null,
            receiveEmailSelected: false,
            contactMethodError: "",
            selectedSpecialty: null,
        };
    },
    methods: {
        async afterValidation(isValid) {
            if (isValid) {
                this.contactMethodError = "";
                sessionStorage.removeItem("state");
                sessionStorage.removeItem("copayCardsSelected");
                if (!this.isCopayCardsMethodSelected) {
                    //do not submit values if an user selects Copay cards, fills info, and then selects another option
                    this.selectedState = null;
                    this.address1 = null;
                    this.address2 = null;
                    this.city = null;
                    this.addressLocation = null;
                    this.company = null;
                    if (this.isMSLMethodSelected) {
                        await this.getState();
                    }
                } else {
                    sessionStorage.setItem("copayCardsSelected", true);
                }

                // Send to CDW
                if (this.isCopayCardsMethodSelected) {
                    var aws =
                        "https://0cpvr1wr3m.execute-api.us-east-1.amazonaws.com/api/form-submission";
                    const config = {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    };
                    axios
                        .post(
                            aws,
                            qs.stringify({
                                contactMethod: this.contactMethodsSelected,
                                Number_of_Copay_Cards_Requested:
                                    this.$refs.form.Number_of_Copay_Cards_Requested.value,
                                salutation: this.selectedSalutation,
                                f_name: this.firstName,
                                l_name: this.lastName,
                                Specialty: this.selectedSpecialty,
                                Address_Location: this.addressLocation,
                                company: this.company,
                                address1: this.address1,
                                address2: this.address2,
                                city: this.city,
                                state: this.selectedState,
                                zip: this.zipCode,
                                email: this.email,
                                preferredMethod: this.$refs.form.preferredMethod.value,
                                phone: this.phoneNumber,
                                certifySelected: this.certifySelected,
                                profile_type: this.$refs.form.profile_type.value,
                                receiveUpdates: this.receiveUpdates,
                                contactMethod: this.ironshoreContactMethod,
                            }),
                            config
                        )
                        .then((response) => { })
                        .catch((e) => {
                            console.log(error);
                        });
                }

                this.$refs.form.submit();
            }
        },
        async getState() {
            const res = await axios.get(url + this.zipCode);
            if (res != null) {
                sessionStorage.setItem("state", res.data.places[0].state);
            }
            return true;
        },
    },
    computed: {
        isPhoneContactSelected() {
            return this.preferredContactMethod === "phone";
        },
        isCopayCardsMethodSelected() {
            return this.ironshoreContactMethod === "Copay Cards";
        },
        isMSLMethodSelected() {
            return this.ironshoreContactMethod === "Medical Liason";
        },
    }



}


</script>